import { createAction } from 'redux-actions'

import { createRequestActions as request } from 'store/actionCreators'
import { REVIEWS_SURVEYS_PATH } from 'app/constants/navLinks'
import { REVIEWS_SURVEY_CREATE_FORM } from 'app/domains/routes/Reviews/ReviewsSurveyCreate'

export const fetchReviewsSurveys = request('REVIEWS_SURVEYS/FETCH_LIST', () => ({
  request: {
    url: `/reviews-surveys`,
  },
}))

export const createReviewsSurvey = request('REVIEWS_SURVEYS/CREATE', values => ({
  request: {
    url: '/reviews-surveys',
    method: 'POST',
    data: values,
  },
  redirect: REVIEWS_SURVEYS_PATH,
  form: REVIEWS_SURVEY_CREATE_FORM,
  success: 'Survey successfully created',
  fail: `Survey wasn't created successfully`,
}))

export const updateReviewsSurvey = request('REVIEWS_SURVEYS/UPDATE', ({ id, data }) => ({
  request: {
    url: `/reviews-surveys/${id}`,
    method: 'PUT',
    data,
  },
  redirect: REVIEWS_SURVEYS_PATH,
  success: 'Survey successfully updated',
}))

export const publishReviewsSurvey = request('REVIEWS_SURVEYS/PUBLISH', id => ({
  request: {
    url: `/reviews-surveys/${id}/publish`,
    method: 'POST',
  },
  redirect: REVIEWS_SURVEYS_PATH,
  success: 'Survey successfully published',
  fail: `Survey wasn't published successfully`,
}))

export const fetchReviewsSurveyById = request('REVIEWS_SURVEYS/FETCH_BY_ID', id => ({
  request: {
    url: `/reviews-surveys/${id}`,
  },
}))

export const triggerReviewsSurveyProcess = createAction('REVIEWS_SURVEYS/TRIGGER_PROCESS')

export const triggerReviewsSurveySubmit = createAction('REVIEWS_SURVEYS/TRIGGER_SUBMIT')

export const doneReviewsSurveyByIdForUser = request('REVIEWS_SURVEYS/DONE_BY_ID_FOR_USER', data => {
  console.log('__doneReviewsSurveyByIdForUser__', data)
  const redirect = data.linkForRedirect
  console.log('__redirect__', redirect)
  delete data.linkForRedirect
  return {
    request: {
      url: `/reviews-surveys/${data.id}/user`,
      method: 'POST',
      data,
    },
    redirect,
  }
})

export const doneReviewsSurveyByIdForReviewer = request('REVIEWS_SURVEYS/DONE_BY_ID_FOR_REVIEWER', data => {
  const redirect = data.linkForRedirect
  delete data.linkForRedirect
  return {
    request: {
      url: `/reviews-surveys/${data.id}/reviewer`,
      method: 'POST',
      data,
    },
    redirect,
  }
})
